import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FacadeService } from 'src/app/shared/services/facade.service';
import { LiteralsState } from '../../reducers/literals.reducer';
import * as selectors from '../../selectors/literals/user-management.selectors';

@Injectable({
  providedIn: 'root',
})
export class UserManagementLiteralsFacadeService extends FacadeService {
  constructor(public override store: Store<LiteralsState>) {
    super(store);
  }

  // OBSERVABLES
  userSearch$ = this.storeSelect(selectors.getUserSearch);
  userSecurityGroups$ = this.storeSelect(selectors.getUserSecurityGroups);
  userPolicyDocs$ = this.storeSelect(selectors.getUserPolicyDocs);
  userUserGroups$ = this.storeSelect(selectors.getUserUserGroups);
  userUserName$ = this.storeSelect(selectors.getUserUserName);
  userDisplayedName$ = this.storeSelect(selectors.getUserDisplayedName);
  userEmail$ = this.storeSelect(selectors.getUserEmail);
  userSecurityGroup$ = this.storeSelect(selectors.getUserSecurityGroup);
  userBusinessGroup$ = this.storeSelect(selectors.getUserBusinessGroup);
  deactivated$ = this.storeSelect(selectors.getDeactivated);
  quicksight$ = this.storeSelect(selectors.getQuicksight);
  createNewUser$ = this.storeSelect(selectors.getCreateNewUser);
  updateUser$ = this.storeSelect(selectors.getUpdateUser);
  userName$ = this.storeSelect(selectors.getUserName);
  newUserPasswd$ = this.storeSelect(selectors.getNewUserPasswd);
  language$ = this.storeSelect(selectors.getLanguage);
  countries$ = this.storeSelect(selectors.getCountries);
  securitygroupTooltip$ = this.storeSelect(selectors.getSecuritygroupTooltip);
  businessgroupTooltip$ = this.storeSelect(selectors.getBusinessgroupTooltip);
  userCode$ = this.storeSelect(selectors.getUserCode);
  deleteFlag$ = this.storeSelect(selectors.getDeleteFlag);
  userDetailsUpdateSuccess$ = this.storeSelect(selectors.getUserDetailsUpdateSuccess);
  userDetailsCreateSuccess$ = this.storeSelect(selectors.getUserDetailsCreateSuccess);
  editPolicy$ = this.storeSelect(selectors.getEditPolicy);
  rolesInDocument$ = this.storeSelect(selectors.getRolesInDocument);
  addRolesInDocument$ = this.storeSelect(selectors.getAddRolesInDocument);
  addPolicyDocsInGroup$ = this.storeSelect(selectors.getAddPolicyDocInGroup);
  policyDocsInGroup$ = this.storeSelect(selectors.getPolicyDocInGroup);
  addUserInGroup$ = this.storeSelect(selectors.getAddUserInGroup);
  usersInGroup$ = this.storeSelect(selectors.getUsersInGroup);
  name$ = this.storeSelect(selectors.getName);
  description$ = this.storeSelect(selectors.getDescription);
  editSecGroup$ = this.storeSelect(selectors.getEditSecGroup);
  createNewPolicyGroup$ = this.storeSelect(selectors.getCreateNewPolicyGroup);
  createNewSecurityGroup$ = this.storeSelect(selectors.getCreateNewSecurityGroup);
  userDeactivationSuccess$ = this.storeSelect(selectors.getUserDeactivationSuccess);
  userActivationSuccess$ = this.storeSelect(selectors.getUserActivationSuccess);

  // OBSERVABLE'S VALUES
  get name() {
    return this.storeSnapshot(this.name$);
  }

  get description() {
    return this.storeSnapshot(this.description$);
  }

  get userUserName() {
    return this.storeSnapshot(this.userUserName$);
  }

  get userDisplayedName() {
    return this.storeSnapshot(this.userDisplayedName$);
  }

  get userEmail() {
    return this.storeSnapshot(this.userEmail$);
  }

  get userCode() {
    return this.storeSnapshot(this.userCode$);
  }

  get deleteFlag() {
    return this.storeSnapshot(this.deleteFlag$);
  }

  get userDetailsUpdateSuccess() {
    return this.storeSnapshot(this.userDetailsUpdateSuccess$);
  }

  get userDetailsCreateSuccess() {
    return this.storeSnapshot(this.userDetailsCreateSuccess$);
  }

  get userDeactivationSuccess() {
    return this.storeSnapshot(this.userDeactivationSuccess$);
  }

  get userActivationSuccess() {
    return this.storeSnapshot(this.userActivationSuccess$);
  }
}
